const COOKIE_DEFAULT_TIME = 1;

function setCookie(name,value,days=COOKIE_DEFAULT_TIME) {
   var expires = "";
   if (days) {
       var date = new Date();
       date.setTime(date.getTime() + (days*24*60*60*1000));
       expires = "; expires=" + date.toUTCString();
   }
   document.cookie = name + "=" + (value || "")  + expires + "; path=/";
   return 1;
}

function cookieExists(name,value) {
   var nameEQ = name + "=" + (value || "");
   var ca = document.cookie.split(';');
   for(var i=0;i < ca.length;i++) {
       var c = ca[i];
       while (c.charAt(0)==' ') c = c.substring(1,c.length);
       if (c.indexOf(nameEQ) == 0) return true;
   }


   return false;
}

function FormCookies(def){
    console.log("[FExt] FormCookies v0.1");

    if(!def.cookies || !Array.isArray(def.cookies)) return;
    console.log("[FExt] Existen cookies en el formulario");
    def.cookies.forEach(c =>{
       var cookieName = c.name;
       var cookieValue = c.set.value;
       var cookieTime = c.set.time;
       if(cookieExists(cookieName,cookieValue)){ 
          console.log("[FExt] La cookie ya existe");
          if(c.presentAction.when == "onload"){
             if(FE$XInterpreter && fe$ngine){
               fe$ngine.executeAST(FE$XInterpreter.parse(c.presentAction.action));
             }else{
                console.log("[FExt] No se ha podido utilizar FE$XInterpreter");
             }
            //c.presentAction.action;

          }else{
             if(!def.submit){
                def.submit = {actions:[]};
             }else if (!Array.isArray(def.submit.actions)){
                def.submit.actions = [];
             }
             def.submit.actions.push({ 
                type:'execute',
                expression:c.presentAction.action,
                time:'immediate'
             });
          }

       }else{
          console.log("[FExt] La cookie no existe aún");
          if(c.set.when == "onload"){ 
             if(c.set.control){
                //var data = [cookieName,cookieValue,cookieTime];
                setCookie(cookieName,cookieValue,cookieTime)
             }
          }else{
             if(!def.submit){
                def.submit = {actions:[]};
             }else if (!Array.isArray(def.submit.actions)){
                def.submit.actions = [];
             }
             def.submit.actions.push({
                type:'execute',
                expression: "call('fe$setCookie','"+cookieName+"','"+cookieValue+"',"+cookieTime+")",
                time:'immediate'
             });
          }
       }
    });
 }

export {FormCookies,setCookie};